import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=2599061f"
import script from "./BaseText.vue?vue&type=script&lang=js"
export * from "./BaseText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports